const projects = [
  {
    id: 1,
    type: 'android',
    name: 'Buscador iTunes',
    shortName: 'iTunes',
    descriptionKey: 'projects.descriptions.1',
    icon: '🎵',
    color: 'linear-gradient(145deg, #1DB954, #147a34)',
    gifSrc: '/demo_buscador_itunes.gif',
    repository: 'https://github.com/jeandealmeida-dev/BuscadorItunes',
    technologies: ['Kotlin', 'MVVM', 'Clean Architecture', 'Retrofit', 'RxAndroid', 'Room', 'Dagger', 'Modularization'],
  },
  {
    id: 2,
    type: 'android',
    name: 'FutMarket App',
    shortName: 'FutMarket',
    descriptionKey: 'projects.descriptions.2',
    icon: '⚽',
    color: 'linear-gradient(145deg, #2196F3, #0d47a1)',
    gifSrc: null,
    repository: 'https://github.com/jeandealmeida-dev/futmarket-app',
    technologies: ['Kotlin', 'Android', 'REST API'],
  },
  {
    id: 3,
    type: 'flutter',
    name: 'Rick & Morty',
    shortName: 'Rick & Morty',
    descriptionKey: 'projects.descriptions.3',
    icon: '👽',
    color: 'linear-gradient(145deg, #00BCD4, #006064)',
    gifSrc: '/trivia.gif',
    repository: 'https://github.com/jeandealmeida-dev/RickAndMorty.Flutter',
    technologies: ['Flutter', 'Dart', 'REST API'],
  },
  {
    id: 4,
    type: 'android',
    name: 'Reign Android Test',
    shortName: 'Reign Test',
    descriptionKey: 'projects.descriptions.4',
    icon: '🏛️',
    color: 'linear-gradient(145deg, #7C4DFF, #4527a0)',
    gifSrc: null,
    repository: 'https://github.com/jeandealmeida-dev/ReignAndroidTest',
    technologies: ['Kotlin', 'Android', 'Clean Architecture'],
  },
];

export default projects;
